var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.468,
    height: 11.273,
    viewBox: "0 0 16.468 11.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_513",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 513",
    d: "M1381.533,883.034l-7.462,9.064-7.462-9.064",
    transform: "translate(1382.305 893.671) rotate(180)",
    fill: "none",
    stroke: "#d19f46",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrUp);
export default __webpack_public_path__ + "static/media/arr_up.614e11bf31dc7748ab3f1c691ce27aaa.svg";
export { ForwardRef as ReactComponent };